var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#FBEBE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.325 21.746c1.337 0 2.006 1.616 1.061 2.561l-6.331 6.331a1.5 1.5 0 0 0-.44 1.064l.006 3.186a1.5 1.5 0 0 0 1.503 1.497l3.177-.005a1.5 1.5 0 0 0 1.058-.44l6.33-6.33c.945-.944 2.561-.275 2.561 1.061v12.325c0 .69-.56 1.25-1.25 1.25H23c-.69 0-1.25-.56-1.25-1.25v-20c0-.69.56-1.25 1.25-1.25h12.325zm7.398-.24a1.25 1.25 0 1 1 1.767 1.768L34.25 33.516a1.248 1.248 0 0 1-2.132-.883c0-.333.131-.653.367-.888l10.239-10.239z",
    fill: "#FF5958"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenIcon);
export default __webpack_public_path__ + "static/media/penIcon.323d58c97c52084b1543caf96280c370.svg";
export { ForwardRef as ReactComponent };